import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useLectureCategory = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [cateList, setCateList] = useState<LectureCategoryListDto[] | any[]>();
    
  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.refcode.lecture.cate.list],
    () =>
      fetcher.refcode.getLectureCategoryList(),
    {
      onSuccess: (res: CommonListResDto) => {
        switch (res.code) {
          case 200:
            if (res.result) {
              setCateList(res.result.list);
            } else {
              setCateList([{cid:0, cname:'미분류'}]);
            }
            
            break;
          case 400:
          default:
            break;
        }
      },
    },
  ); 

  const { mutate: categoryInsert } = useMutation(
    [endpoints.refcode.lecture.cate.add],
    fetcher.refcode.postLectureCategoryInsert,
    {
      onSuccess: (res, param) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: categoryUpdate } = useMutation(
    [endpoints.refcode.lecture.cate.update],
    fetcher.refcode.postLectureCategoryUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { isLoading, cateList, refetch, categoryInsert, categoryUpdate };
};

export default useLectureCategory;
